import React, { useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import bg from '../../../assets/intro2.jpg'
import bg2 from '../../../assets/1080p.jpeg'
import bg3 from '../../../assets/1080p2.jpg'
import { Link as RouterLink } from 'react-router-dom'
import { TypeAnimation } from 'react-type-animation';
import './carousel.css';
import './intro.css';

export function EmblaCarousel() {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ stopOnInteraction: false, delay: 9500 })])

    return (
        <div className="embla" ref={emblaRef}>
            <div className="embla__container">
                <div className="embla__slide">
                    <img src={bg} alt="" style={{ filter: 'brightness(0.7)' }} />
                    <div className="introContent1">
                        <div className='introPara'>
                            <div className='introHeader'>
                                Welcome to NTU's first collaboration platform.
                            </div>
                            <div className='introLines'>
                                <TypeAnimation
                                    sequence={[
                                        'Looking for new projects to take on ?',
                                        1000,
                                        'Collaborating has never been easier.',
                                        1000,
                                        'Here are some tips for you.',
                                        1000
                                    ]}
                                    wrapper="span"
                                    speed={65}
                                    style={{ fontSize: '3rem', display: 'inline-block', fontWeight: '600' }}
                                    repeat={Infinity}
                                />
                            </div>
                            <div className='introFooter'>
                                Check out the list of projects
                                <RouterLink to='/projectlist' className='linkBtn'><button className='introBtn1'> Here</button></RouterLink>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="embla__slide">
                    <img src={bg3} alt="" />
                    <div className="introContent">
                        <span className='hello'>guide</span>
                        <span className='introName'>Start your own projects</span>
                        <span className='introPara'>
                            <span className='projpara'>Create a page for your project to attract members!
                                Add tags relavlent to the project to find the right people for the job.
                            </span>
                            <span className='projskills'></span>
                        </span>
                        <div id="introBtns">
                            <RouterLink to='/startproject' className='linkBtn'><button className='introBtn'>Start Your Own Project</button></RouterLink>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
